export const _escapes = /\\([!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~])/g
